import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-candidate-modal',
  templateUrl: './candidate-modal.component.html',
  styleUrls: ['./candidate-modal.component.css'],
})
export class CandidateModalComponent implements OnInit {
  @Input() candidateID: any;
  @Input() isPortalAdmin!:boolean;
  @Input() clientCorporation: string='';
  @Input() clientID:any;
  @Input() clientEmail: string = '';
  @Input() modalType: 'candidate' | 'client' = 'candidate';
  active = 1;
  showNewTaxFile:boolean=false;
  candidateName:string='';
  candidateEmail:string='';
  navItems: any[] = [];

  constructor(public activeModal: NgbActiveModal, private http: HttpClient) {}

  ngOnInit(): void {
    if(this.modalType=='candidate' ){
      var payAdviceUrl = environment.apiConfig.uri + `/admin/Candidates/GetPayAdvices/${this.candidateID}`;
      this.http.get(payAdviceUrl).subscribe(async (res: any) => {
        this.candidateName=res.data.name;
        this.candidateEmail=res.data.email;      
      });
    }
    this.initializeNavItems();
  }
  private initializeNavItems() {
    if (this.modalType === 'candidate') {
      this.navItems = [
        { id: 1, title: 'Status', component: 'app-candidate-status' },
        { id: 2, title: 'Details', component: 'app-candidate-details' },
        { id: 3, title: 'Jobs', component: 'app-candidate-jobs' },
        { id: 4, title: 'History', component: 'app-candidate-history' },
        { id: 5, title: 'Documents', component: 'app-candidate-documents' },
        { id: 6, title: 'Training Assessment', component: 'app-candidate-training' },
        { id: 7, title: 'Notes', component: 'app-candidate-notes' },

        { id: 8, title: 'Deductions', component: 'app-candidate-deductions' },
        { id: 9, title: 'Tax & Super', component: 'app-tax-super' },
        { id: 10, title: 'Bank Details', component: 'app-bank-details' },
        { id: 11, title: 'Payroll History', component: 'app-candidate-payroll-history' },
      ];
    } else {
      this.navItems = [
        { id: 1, title: 'Status', component: 'app-client-status' },
        { id: 2, title: 'Details', component: 'app-client-details' },
        { id: 3, title: 'Organization', component: 'app-client-organization' },
        { id: 4, title: 'Jobs', component: 'app-client-jobs' },
        { id: 5, title: 'Candidates', component: 'app-client-candidates' },
        { id: 6, title: 'Reports', component: 'app-client-reports' }
      ];
    }
  }

  receiveParentValue(value: boolean) {
    this.showNewTaxFile=value;
  }
}
